import { useTranslation } from 'next-i18next'

import WindSurferScoreAndStreak from './WindSurferScoreAndStreak'

interface Props {
  bestScore: number
  bestStreak: number
  bestLevel: number
}

export default function ActivitySummary({ bestScore, bestStreak, bestLevel }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')

  return (
    <div className="mt-2">
      <div className="flex flex-col lg:flex-row lg:space-x-4 pt-2">
        <WindSurferScoreAndStreak
          imgSrcKey="scoreboard/star2.svg"
          text={t('windSurfer.bestScore')}
          value={bestScore || 0}
        />
        <WindSurferScoreAndStreak
          imgSrcKey="scoreboard/fire.svg"
          text={t('windSurfer.bestStreak')}
          value={bestStreak || 0}
        />
      </div>
      <div className="w-full font-semibold rounded overflow-hidden shadow-card space-y-2 py-2 mb-2">
        <p className="text-center">
          <span className="text-purple">{t('windSurfer.bestLevel')}</span>
        </p>
        <p className="text-center font-semibold">{bestLevel || 0}</p>
      </div>
    </div>
  )
}
